export default __webpack_public_path__ + "static/media/mail.39fc3a37.svg";